/* eslint-disable */

import { Size } from "../../../logic/enums.ts";
import { URL_RAINDROP } from "../../../services/constants.js";
import FlexCol from "../../../ui-components/flex-col/flex-col.tsx";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import RaindropPage from "../../../ui-components/raindrop-page/raindrop-page.tsx";
import RaindropTextCallout from "../../../ui-components/raindrop-text-callout/raindrop-text-callout.tsx";

const RaindropNotFound = () => {
  return (
    <RaindropPage className="justify-center">
      <FlexCol tailwindGap="gap-8">
        <i className="fa fa-heart-crack text-8xl" />
        <RaindropTextCallout
          text={"Oops!  We can't find that page"}
          isPrimary={false}
          className="text-center"
        />
        <RaindropButton
          title="Return Home"
          style={ButtonStyle.Primary}
          size={Size.Large}
          to={URL_RAINDROP}
        />
      </FlexCol>
    </RaindropPage>
  );
};

export default RaindropNotFound;
